import {
  FormControl,
  FormControlProps,
  FormHelperText,
  FormLabel,
  FormLabelProps,
  InputBase,
  InputBaseProps,
  formLabelClasses,
  inputBaseClasses,
} from '@mui/material';

import { SxPropsOverrides } from '../../types/markup';
import { applySxOverrides } from '../../helpers/functions/markup';

export default function TextField({
  label,
  formControlProps,
  formLabelProps,
  styles,
  helperText,
  ...inputBaseProps
}: {
  label?: string;
  formControlProps?: FormControlProps;
  formLabelProps?: FormLabelProps;
  helperText?: string;
  styles?: {
    formControl?: SxPropsOverrides;
    formLabel?: SxPropsOverrides;
    inputBase?: SxPropsOverrides;
  };
} & InputBaseProps) {
  return (
    <FormControl
      sx={(theme) => ({
        justifyContent: 'flex-end',
        ...applySxOverrides(styles?.formControl, theme),
      })}
      {...formControlProps}
    >
      {label && (
        <FormLabel
          sx={(theme) => ({
            fontWeight: 500,
            py: '5px',
            color: theme.palette.secondary.dark,
            [`&.${formLabelClasses.focused}`]: {
              color: theme.palette.secondary.dark,
            },
          })}
          {...formLabelProps}
        >
          {label}
        </FormLabel>
      )}
      <InputBase
        sx={(theme) => ({
          px: '6px',
          py: '2px',
          border: `1px solid ${theme.palette.secondary.light}`,
          borderRadius: '2px',
          backgroundColor: theme.palette.common.white,
          [`&.${inputBaseClasses.focused}`]: {
            borderColor: theme.palette.primary.main,
          },
          [`& .${inputBaseClasses.input}`]: {
            color: theme.palette.secondary.dark,
            height: '18px',
            p: 0,
          },
          ...applySxOverrides(styles?.inputBase, theme),
        })}
        {...inputBaseProps}
      />
      {helperText && (
        <FormHelperText error={inputBaseProps.error} sx={{ ml: 0 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
